import styled from '@emotion/styled'

export const DateFieldsWrapper = styled.div`
  grid-column-end: 5;
  grid-column-start: 3;
`
